/**
 * Created by zad on 17/11/16.
 */
import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

export default class LazyRenderBox extends Component {
  static propTypes = {
    className: PropTypes.string,
    visible: PropTypes.bool,
    hiddenClassName: PropTypes.string,
    role: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    style: {},
  };

  // eslint-disable-next-line class-methods-use-this
  shouldComponentUpdate(nextProps) {
    return !!nextProps.hiddenClassName || !!nextProps.visible;
  }

  render() {
    const { className, hiddenClassName, visible } = this.props;
    const boxClass = classNames(className, {
      [`${hiddenClassName}`]: !!hiddenClassName && !visible,
    });
    const props = _.omit(Object.assign({}, this.props), ['hiddenClassName', 'visible']);
    return <div {...props} className={boxClass}/>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/LazyRenderBox.js